//to capitalize only first letter
export const capitalizeFirstLetter = (string) => {
  if (
    !string ||
    typeof string !== "string" ||
    (string && string.trim().length === 0)
  )
    return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const dateToString = (date, locale = 'en-US') => {
  return new Date(date).toLocaleDateString(locale);
}

export const listStringToObject = (data, first) => {
  const result =  data?.raw?.map(j => JSON.parse(j));

  if (first) {
    return result && result.length > 0 ? result[0]: undefined;
  }

  return result || [];
}